import { useSelector } from 'react-redux';

import * as accessoriesSelectors from '@makemydeal/dr-dash-store/selectors/accessoriesSelectors';
import * as dealModeSelectors from '@makemydeal/dr-dash-store/selectors/dealModeSelectors';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import type { IPaymentGridErrorState, StateTree } from '@makemydeal/dr-dash-types';
import { LEASE } from '@makemydeal/dr-platform-types';
import { dealerSelectors } from '@makemydeal/dr-shared-store';

export const useSummaryBanners = () => {
    const currentOfferType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const isDealCentralExperience = useSelector(dealerSelectors.isDealCentralExperience);
    const isDealCentralWithFnI = useSelector(dealerSelectors.isDealCentralWithFnI);
    const isFnIDealMode = useSelector(dealModeSelectors.isFnIDealMode);
    const paymentGridEnabledToggle = useSelector((state: StateTree) =>
        offerReduxSelectors.getPaymentGridToggle(state, currentOfferType)
    );
    const isFlexBuyPayment = useSelector(offerReduxSelectors.isFlexBuyPayment);
    const flexBuyPaymentGridEnabled = useSelector(offerReduxSelectors.getFlexBuyPaymentGridToggle);
    const isCreditDecisionEnabled = useSelector(offerReduxSelectors.getCreditDecisionEnabled);
    const paymentGridErrorState: IPaymentGridErrorState = useSelector(offerReduxSelectors.getPaymentGridErrorState);
    const hasPaymentGridColumnMessage = useSelector(offerReduxSelectors.hasPaymentGridColumnMessage);
    const isAspPaymentGridRedesignActive = useSelector((state: StateTree) =>
        offerReduxSelectors.isAspPaymentGridRedesignActive(state, LEASE)
    );
    const areAccessoryPricesAdjusted = useSelector(accessoriesSelectors.getAreAccessoryPricesAdjusted);

    const isFniModeActive = isDealCentralWithFnI && isFnIDealMode;
    const isPaymentGridEnabled =
        (isFlexBuyPayment ? flexBuyPaymentGridEnabled : paymentGridEnabledToggle) && isDealCentralExperience && !isFniModeActive;

    return {
        showsLeasePaymentGridDisclaimer:
            isPaymentGridEnabled && !isCreditDecisionEnabled && currentOfferType === LEASE && !isAspPaymentGridRedesignActive,
        showsPaymentGridError: !!paymentGridErrorState.hasError && isPaymentGridEnabled && !hasPaymentGridColumnMessage,
        showsAccessoryPricesAdjusted: areAccessoryPricesAdjusted,
        showsAutoSelectedLenderProgram: !isFniModeActive
    };
};
